import { render, staticRenderFns } from "./MedicalNicheIcon.vue?vue&type=template&id=421873a6&scoped=true"
import script from "./MedicalNicheIcon.vue?vue&type=script&lang=js"
export * from "./MedicalNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421873a6",
  null
  
)

export default component.exports